/*
 * Prime Phones — Add to cart feel (see snippets/pp-motion-head.liquid for the
 * shared timing and switches, snippets/pp-atc-sheet.liquid for the panel).
 *
 * The theme still does the adding exactly as before (product-form.js); this
 * only changes what the shopper sees, and never claims success before the
 * store has confirmed it — most phones are the last one.
 *
 * INSTANT PANEL (Theme settings → Add to cart → "Instant panel"; idea from
 * Swopp). The moment an Add to cart button is pressed, a panel shows that
 * phone (photo, name, storage · colour, condition, battery, price) with
 * "Adding to your cart…". When the store answers it turns into "Added to
 * your cart" (Checkout comes alive), "already in your cart", "just been
 * sold" (with a link to other phones) or "didn't go through". The theme's
 * drawer then no longer pops open by itself; "View cart" opens it. Buttons
 * whose phone is in the cart change to "In your cart · View" and open the
 * cart instead of adding again. If this script doesn't load, the theme
 * behaves exactly as before (the drawer opens after adding).
 *
 * MOTION (html.pp-m-cart), after the store confirms: the pressed button
 * draws a tick; the cart count pops; with the drawer (not the panel), the
 * phone's photo glides into its new line and the line glows.
 */
(function () {
  if (window.__ppMotion) return;
  window.__ppMotion = true;

  var html = document.documentElement;

  /* ================= play when it scrolls into view =================
     Parts further down the page (the comparison table, the review row, and
     anything marked data-pp-reveal) get .pp-in just before they come on
     screen, which starts their one-time animation (CSS). Nothing is hidden
     beforehand: if this never runs, they simply show as they are. Anything
     already on screen when the page loads is marked .pp-seen and left
     still — nothing near the top animates in. */
  if (html.classList.contains('pp-m') && 'IntersectionObserver' in window) {
    var REVEAL = '.ppx, .ppgr__track, [data-pp-reveal]';
    /* Theme settings → Motion → "Pages: cards bounce in" (styles: pp-motion-head). */
    if (html.classList.contains('pp-m-pages')) REVEAL += ', .ppg__step, .ppg__grade, .ppg__box, .ppg__after, .ppg__policy, .ppg__panel, .ppw2__card, .ppw2__step, .ppw2__part, .ppk__card, .ppct__tc';
    var io = new IntersectionObserver(function (entries) {
      var n = 0;
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        /* Several at once (a row of cards): one after another, 60 ms apart. */
        e.target.style.setProperty('--pp-stagger', Math.min(n++, 5) * 60 + 'ms');
        e.target.classList.add('pp-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px 80px 0px' });
    var watch = function () {
      document.querySelectorAll(REVEAL).forEach(function (el) {
        if (el.__ppRv) return;
        el.__ppRv = true;
        var r = el.getBoundingClientRect();
        if (r.top < innerHeight && r.bottom > 0) { el.classList.add('pp-seen'); return; }
        io.observe(el);
      });
    };
    watch();
    document.addEventListener('shopify:section:load', watch);
    document.addEventListener('pp:section:load', watch); /* a page swapped in by the bottom bar */
    window.PPReveal = watch;
  }

  /* ================= "Save R…" pills gleam (30 Sept 2026) =================
     User: the saving should gleam once or twice. A soft light sweeps across
     the pill twice, the first time it is properly on screen (cards as their
     row arrives, the product page's pill at once, the menu's when it opens).
     Nothing changes size or position; the pill is always readable. */
  if (html.classList.contains('pp-m') && 'IntersectionObserver' in window) {
    var SAVE = '.ppc__save, .ppcc__save, .pp-mega__save';
    var gio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        gio.unobserve(e.target);
        var el = e.target;
        /* On screen while the page is still loading (the product page's pill):
           wait until it has loaded and settled, so the gleam is actually seen. */
        if (document.readyState === 'complete') el.classList.add('pp-gleam');
        else window.addEventListener('load', function () { setTimeout(function () { el.classList.add('pp-gleam'); }, 700); }, { once: true });
      });
    }, { threshold: 0.9 });
    var gleamWatch = function () {
      document.querySelectorAll(SAVE).forEach(function (el) {
        if (el.__ppGl) return;
        el.__ppGl = true;
        gio.observe(el);
      });
    };
    gleamWatch();
    document.addEventListener('shopify:section:load', gleamWatch);
    document.addEventListener('pp:section:load', gleamWatch); /* a page swapped in by the bottom bar */
    window.addEventListener('load', gleamWatch, { once: true });
  }

  /* ================= product cards: lift + second photo (batch 3) =================
     Computers only (a real hover). The second photo (usually a photo of the
     actual device) downloads on the first hover, not with the page; the
     card lifts a few pixels. Styles: pp-collection.css. */
  if (html.classList.contains('pp-m-coll') && window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('pointerover', function (e) {
      var box = e.target.closest && e.target.closest('.ppcc__img[data-pp-alt]');
      if (!box || box.__ppAlt) return;
      box.__ppAlt = true;
      var img = new Image();
      img.className = 'ppcc__photo-alt';
      img.alt = '';
      img.decoding = 'async';
      img.onload = function () { box.classList.add('has-alt'); };
      img.src = box.getAttribute('data-pp-alt');
      box.appendChild(img);
    }, { passive: true });
  }

  var cartMotion = html.classList.contains('pp-m-cart');
  var full = html.classList.contains('pp-m');
  var sheet = document.querySelector('[data-ppas]');
  if (!cartMotion && !sheet) return; /* (the reveal helper above has already started) */
  var speed = parseFloat(getComputedStyle(html).getPropertyValue('--pp-speed')) || 1;

  /* With the panel, the drawer stays shut after adding ("View cart" opens it). */
  if (sheet && window.theme && theme.settings && theme.settings.cartDrawer) {
    theme.settings.cartDrawer.atcAction = 'pp-panel';
  }

  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 8 && r.height > 8 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth;
  }

  function sourcePhoto(button) {
    var card = button.closest('[data-pp-card], .card-wrapper, .card');
    var pick = [];
    if (card) pick.push(card.querySelector('img'));
    var sticky = button.closest('[data-pp-sticky]');
    if (sticky) pick.push(sticky.querySelector('img'));
    pick.push(document.querySelector('.product__media-wrapper media-gallery .product__media-item.is-active img'));
    pick.push(document.querySelector('[data-pp-sticky].is-on img'));
    for (var i = 0; i < pick.length; i++) if (visible(pick[i])) return pick[i];
    return null;
  }

  function variantOf(button) {
    var form = button.form || button.closest('form');
    if (!form) return null;
    var id = form.querySelector('[name="id"]');
    return id ? String(id.value) : null;
  }

  function openDrawer(from) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(from);
      return true;
    }
    location.href = (window.routes && routes.cart_url) || '/cart';
    return false;
  }

  /* ================= the instant panel ================= */
  var S = sheet ? {
    panel: sheet.querySelector('[data-ppas-panel]'),
    state: '',
    variant: null,
    button: null,
    closeTimer: 0
  } : null;

  function q(sel) { return sheet.querySelector(sel); }

  function fill(data, photo) {
    sheet.setAttribute('data-kind', (data && data.k) || 'pre');
    var img = q('[data-ppas-img]');
    var src = (data && data.i) || (photo && (photo.currentSrc || photo.src)) || '';
    if (src) { img.src = src; img.hidden = false; } else img.hidden = true;
    q('[data-ppas-name]').textContent = (data && data.n) || document.title.split('–')[0].trim();
    q('[data-ppas-sub]').textContent = (data && data.s) || '';
    var cond = q('[data-ppas-cond]');
    cond.textContent = (data && data.c) || '';
    var bat = q('[data-ppas-bat]');
    var b = data && Number(data.b);
    if (b > 0) {
      bat.hidden = false;
      q('[data-ppas-bat-text]').textContent = String(sheet.getAttribute('data-battery') || '[n]% battery').replace('[n]', b);
      q('[data-ppas-bat-fill]').setAttribute('width', (13.3 * Math.min(100, b) / 100).toFixed(2));
    } else {
      bat.hidden = true;
    }
    q('[data-ppas-price]').textContent = (data && data.p) || '';
    q('[data-ppas-save]').textContent = data && data.sv ? String(sheet.getAttribute('data-save') || 'Save [amount]').replace('[amount]', data.sv) : '';
  }

  /* A button without the details (an app's widget, say): read what the card
     around it shows, so the panel is never bare. */
  function fromCard(button) {
    var card = button.closest('[data-pp-card], .card-wrapper, .card, product-card, li, .product');
    if (!card) return null;
    var pick = function (sels) {
      for (var i = 0; i < sels.length; i++) {
        var e = card.querySelector(sels[i]);
        if (e && e.textContent.trim()) return e.textContent.trim().replace(/\s+/g, ' ');
      }
      return '';
    };
    return {
      n: pick(['.card__heading', '.ppcc__title', 'h3', 'h2', '.product__title']),
      s: '',
      c: '',
      b: 0,
      p: pick(['.price-item--sale', '.price-item--regular', '.price-item', '.price']),
      i: ''
    };
  }

  function setState(s) {
    sheet.classList.remove('is-adding', 'is-added', 'is-already', 'is-sold', 'is-error');
    sheet.classList.add('is-' + s);
    S.state = s;
  }

  function openSheet() {
    clearTimeout(S.closeTimer);
    sheet.hidden = false;
    document.body.classList.add('ppas-open');
    void sheet.offsetWidth;
    sheet.classList.add('is-open');
    S.panel.style.transform = '';
    try { S.panel.focus({ preventScroll: true }); } catch (e) { S.panel.focus(); }
  }

  function closeSheet(keepFocus) {
    if (sheet.hidden) return;
    sheet.classList.remove('is-open', 'is-dragging');
    S.panel.style.transform = '';
    document.body.classList.remove('ppas-open');
    var instant = !full;
    S.closeTimer = setTimeout(function () { sheet.hidden = true; }, instant ? 0 : 480 * speed);
    if (!keepFocus && S.button && document.contains(S.button)) {
      try { S.button.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
    }
  }

  /* Buttons whose phone is in the cart open the cart instead of adding. */
  function markInCart(variant) {
    if (!sheet || !variant) return;
    document.querySelectorAll('button[name="add"], button[type="submit"][form]').forEach(function (b) {
      if (b.closest('cart-drawer') || variantOf(b) !== String(variant) || b.classList.contains('pp-in-cart')) return;
      var label = null;
      var spans = b.querySelectorAll(':scope > span');
      for (var i = spans.length - 1; i >= 0; i--) {
        var sp = spans[i];
        if (sp.classList.contains('loading__spinner') || sp.classList.contains('icon-wrap') || sp.classList.contains('pp-added-mark') || sp.classList.contains('sold-out-message')) continue;
        if (sp.textContent.trim()) { label = sp; break; }
      }
      if (!label) return;
      b.classList.add('pp-in-cart');
      b.setAttribute('data-pp-label', label.textContent);
      var small = b.classList.contains('quick-add__submit');
      label.textContent = small ? (sheet.getAttribute('data-in-cart-short') || 'In cart') : sheet.getAttribute('data-in-cart');
    });
  }

  function clearInCart() {
    document.querySelectorAll('.pp-in-cart').forEach(function (b) {
      var spans = b.querySelectorAll(':scope > span');
      for (var i = spans.length - 1; i >= 0; i--) {
        var sp = spans[i];
        if (sp.classList.contains('loading__spinner') || sp.classList.contains('icon-wrap') || sp.classList.contains('pp-added-mark') || sp.classList.contains('sold-out-message')) continue;
        if (sp.textContent.trim()) { sp.textContent = b.getAttribute('data-pp-label') || sp.textContent; break; }
      }
      b.classList.remove('pp-in-cart');
      b.removeAttribute('data-pp-label');
    });
  }

  if (sheet) {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.pp-in-cart');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      openDrawer(b);
    }, true);

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-ppas-close]')) { closeSheet(); return; }
      if (e.target.closest('[data-ppas-view]')) { closeSheet(true); openDrawer(S.button); return; }
      var co = e.target.closest('[data-ppas-checkout]');
      if (co && S.state !== 'added' && S.state !== 'already') e.preventDefault();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) closeSheet();
    });

    /* Back from checkout (page restored as it was): no panel left open. */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && !sheet.hidden) {
        sheet.classList.remove('is-open');
        sheet.hidden = true;
        document.body.classList.remove('ppas-open');
      }
    });

    /* Phones: swipe the sheet down to close it. */
    var drag = null;
    S.panel.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1 || S.panel.scrollTop > 0 || window.matchMedia('(min-width: 750px)').matches) return;
      drag = { y: e.touches[0].clientY, t: e.timeStamp, dy: 0, v: 0, on: false };
    }, { passive: true });
    S.panel.addEventListener('touchmove', function (e) {
      if (!drag) return;
      var dy = e.touches[0].clientY - drag.y;
      if (!drag.on) {
        if (dy < 8) { if (dy < -8) drag = null; return; }
        drag.on = true;
        sheet.classList.add('is-dragging');
      }
      var dt = e.timeStamp - drag.t;
      if (dt > 0) drag.v = (dy - drag.dy) / dt;
      drag.t = e.timeStamp;
      drag.dy = Math.max(0, dy);
      S.panel.style.transform = 'translateY(' + drag.dy + 'px)';
    }, { passive: true });
    function endDrag() {
      if (!drag) return;
      var d = drag;
      drag = null;
      if (!d.on) return;
      sheet.classList.remove('is-dragging');
      if (d.dy > 90 || d.v > 0.5) closeSheet();
      else S.panel.style.transform = '';
    }
    S.panel.addEventListener('touchend', endDrag, { passive: true });
    S.panel.addEventListener('touchcancel', endDrag, { passive: true });
  }

  /* ================= the moment of pressing ================= */
  var last = null;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest || !form.closest('product-form')) return;
    var button = e.submitter || form.querySelector('[type="submit"][name="add"], [type="submit"]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;
    var inDrawer = !!button.closest('cart-drawer');
    var photo = sourcePhoto(button);
    var variant = (new FormData(form)).get('id');
    last = {
      button: button,
      photo: full ? photo : null,
      rect: full && photo ? photo.getBoundingClientRect() : null,
      src: photo ? (photo.currentSrc || photo.src) : '',
      variant: variant,
      panel: !!sheet && !inDrawer,
      t: Date.now()
    };
    if (last.panel) {
      var data = null;
      try { data = JSON.parse(button.getAttribute('data-pp-atc') || 'null'); } catch (err) { data = null; }
      if (!data) data = fromCard(button);
      S.variant = String(variant);
      S.button = button;
      fill(data, photo);
      setState('adding');
      openSheet();
    }
  }, true);

  /* ================= the store's answer ================= */
  var TICK = '<svg viewBox="0 0 24 24" fill="none" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function tick(button) {
    if (!cartMotion || !button || !document.contains(button)) return;
    var mark = button.querySelector(':scope > .pp-added-mark');
    if (!mark) {
      mark = document.createElement('span');
      mark.className = 'pp-added-mark';
      mark.setAttribute('aria-hidden', 'true');
      mark.innerHTML = TICK;
      button.appendChild(mark);
      button.classList.add('pp-has-mark');
    }
    button.classList.remove('pp-added');
    void button.offsetWidth;
    button.classList.add('pp-added');
    clearTimeout(button.__ppAdded);
    button.__ppAdded = setTimeout(function () { button.classList.remove('pp-added'); }, 1500);
  }

  function lineFor(variant) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('active')) return null;
    var a = variant && drawer.querySelector('.cart-item a[href*="variant=' + variant + '"]');
    return a ? a.closest('.cart-item') : drawer.querySelector('.cart-item');
  }

  function glow(row) {
    if (!row) return;
    row.classList.remove('pp-just-added');
    void row.offsetWidth;
    row.classList.add('pp-just-added');
    setTimeout(function () { row.classList.remove('pp-just-added'); }, 1800);
  }

  function whenSettled(variant, done) {
    var t0 = performance.now();
    var prev = null;
    var steady = 0;
    (function frame() {
      var row = lineFor(variant);
      var img = row && row.querySelector('.cart-item__image, img');
      if (img) {
        var r = img.getBoundingClientRect();
        if (prev && Math.abs(r.left - prev.left) < 0.5 && Math.abs(r.top - prev.top) < 0.5 && r.width > 0) steady++;
        else steady = 0;
        prev = r;
        if (steady >= 2) return done(row, img, r);
      }
      if (performance.now() - t0 > 1500) return done(row, null, null);
      requestAnimationFrame(frame);
    })();
  }

  function fly(from, src, row, target, to) {
    if (!from || !src || !target || !to || !full) { glow(row); return; }
    var ghost = document.createElement('img');
    ghost.src = src;
    ghost.alt = '';
    ghost.className = 'pp-fly';
    ghost.style.left = from.left + 'px';
    ghost.style.top = from.top + 'px';
    ghost.style.width = from.width + 'px';
    ghost.style.height = from.height + 'px';
    document.body.appendChild(ghost);
    target.style.opacity = '0';
    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + from.height / 2);
    var s = Math.max(to.width / from.width, to.height / from.height);
    var lift = Math.min(90, Math.abs(dy) * 0.25 + 30);
    var anim = ghost.animate([
      { transform: 'translate(0, 0) scale(1)', opacity: 1, borderRadius: '14px' },
      { transform: 'translate(' + dx * 0.55 + 'px, ' + (dy * 0.55 - lift) + 'px) scale(' + (1 + (s - 1) * 0.5) + ')', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(' + s + ')', opacity: 1, borderRadius: '10px' }
    ], { duration: 560 * speed, easing: 'cubic-bezier(0.45, 0, 0.2, 1)', fill: 'forwards' });
    var finish = function () {
      target.style.opacity = '';
      ghost.remove();
      glow(row);
    };
    anim.onfinish = finish;
    anim.oncancel = finish;
    setTimeout(function () { if (ghost.isConnected) finish(); }, 1400 * speed);
  }

  var recent = null;
  function added() {
    var info = last;
    last = null;
    if (!info || Date.now() - info.t > 20000) return;
    recent = { variant: String(info.variant), t: Date.now() };
    tick(info.button);
    if (info.panel && sheet) {
      if (S.variant === String(info.variant)) setState('added');
      markInCart(info.variant);
      return;
    }
    if (!cartMotion) return;
    whenSettled(info.variant, function (row, img, rect) {
      if (!row) return;
      if (info.photo && img && rect) fly(info.rect, info.src, row, img, rect);
      else glow(row);
    });
  }

  function failed(data) {
    var info = last;
    last = null;
    if (!info || !info.panel || !sheet || S.variant !== String(info.variant)) return;
    var msg = String((data && (data.errors || data.message)) || '');
    /* "Sold out" first: Shopify says "…is already sold out", which must not
       read as "already in your cart". */
    var handled = true;
    if (/sold out|out of stock|not available|unavailable|no longer/i.test(msg)) {
      setState('sold');
    } else if (/already|can.?t add|cannot add|maximum|all \d+/i.test(msg)) {
      setState('already');
      markInCart(info.variant);
    } else {
      setState('error');
      handled = false;
    }
    /* The panel already says it (kindly); the theme's red message under the
       price would repeat it. It's shown right after this, so hide it next. */
    if (handled) {
      var pf = (info.button.form || info.button).closest && (info.button.form || info.button).closest('product-form');
      var box = pf && pf.querySelector('.product-form__error-message-wrapper');
      if (box) setTimeout(function () { box.hidden = true; }, 0);
    }
  }

  function listen() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    /* Ignite renames the buy buttons' "cart updated" message to "cart add"
       (global.js publish()); listen for that, and for the plain one. */
    if (PUB_SUB_EVENTS.cartAdd) subscribe(PUB_SUB_EVENTS.cartAdd, function () { added(); });
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
      if (e && e.source === 'product-form') added();
    });
    subscribe(PUB_SUB_EVENTS.cartError, failed);
    if (PUB_SUB_EVENTS.cartRemove) subscribe(PUB_SUB_EVENTS.cartRemove, clearInCart);
    /* Neither answer (network trouble): don't leave the panel "adding". */
    subscribe('quick-buy-action-complete', function () {
      setTimeout(function () {
        if (sheet && S.state === 'adding' && !sheet.hidden) { setState('error'); last = null; }
      }, 60);
    });
    return true;
  }
  if (!listen()) document.addEventListener('DOMContentLoaded', listen, { once: true });

  /* ================= cart drawer (batch 3) =================
     - Opened after an add: the line for the phone just added glows once.
     - Totals and line prices roll to their new figure when they change.
     - A line being removed dims until the store has answered (it isn't
       shown as gone before then).
     - The Checkout button shines once as the drawer opens (CSS). */
  var drawerEl = document.querySelector('cart-drawer');
  if (cartMotion && drawerEl && 'MutationObserver' in window) {
    var wasOpen = drawerEl.classList.contains('active');
    new MutationObserver(function () {
      var open = drawerEl.classList.contains('active');
      if (open && !wasOpen && recent && Date.now() - recent.t < 120000) {
        var v = recent.variant;
        recent = null;
        setTimeout(function () {
          var a = drawerEl.querySelector('.cart-item a[href*="variant=' + v + '"]');
          if (a) glow(a.closest('.cart-item'));
        }, 380);
      }
      wasOpen = open;
    }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });

    var figures = function () {
      var m = {};
      drawerEl.querySelectorAll('.totals__total-value, .cart-item__price-wrapper .price').forEach(function (el, i) { m[i] = el.textContent.trim(); });
      return m;
    };
    var seen = figures();
    new MutationObserver(function () {
      var now = figures();
      drawerEl.querySelectorAll('.totals__total-value, .cart-item__price-wrapper .price').forEach(function (el, i) {
        if (seen[i] !== undefined && seen[i] !== now[i] && !el.classList.contains('pp-roll')) {
          el.classList.add('pp-roll');
          setTimeout(function () { el.classList.remove('pp-roll'); }, 600);
        }
      });
      seen = now;
    }).observe(drawerEl, { childList: true, subtree: true, characterData: true });

    drawerEl.addEventListener('click', function (e) {
      var rm = e.target.closest && e.target.closest('cart-remove-button');
      var row = rm && rm.closest('.cart-item');
      if (row) row.classList.add('pp-removing');
    });
  }

  /* ================= the cart count pops ================= */
  var bubbleHost = document.getElementById('cart-icon-bubble');
  if (cartMotion && bubbleHost && 'MutationObserver' in window) {
    var lastCount = (bubbleHost.querySelector('.cart-count-bubble span') || {}).textContent;
    new MutationObserver(function () {
      var bubble = bubbleHost.querySelector('.cart-count-bubble');
      var span = bubble && bubble.querySelector('span');
      var now = span ? span.textContent : '';
      if (!span || now === lastCount) { lastCount = now; return; }
      lastCount = now;
      bubble.classList.remove('pp-roll');
      void bubble.offsetWidth;
      bubble.classList.add('pp-roll');
    }).observe(bubbleHost, { childList: true, subtree: true, characterData: true });
  }
})();
